import axios from 'axios';
import {
  Configuration,
  FeatureSubscriptionControllerApiFactory,
  FeatureSubscriptionRequest,
  DiscountSettingsControllerApiFactory,
  BillingControllerApiFactory,
} from '@ce-openapi/business-subscription-service-ts-axios-client';
import { getSaudagarOutlets } from '../outlets';
import {
  BILLINGS,
  BUSINESS_SUBSCRIPTION,
  CANCEL_SUBSCRIPTION,
  FEATURE_SUBSCRIPTION_PRICE,
  GET_PRORATE_PRICE,
  IS_ACTIVE_SUBCRIPTIONS_URL,
  RULES,
  SUBSCRIPTION_STATUS,
  VERIFY_BILLING,
  VERIFY_BILLING_FOR_EXTEND_OUTLET,
} from './constant';

function reject(error) {
  let eobj;
  if (error.response) {
    const { data } = error.response;
    if (data.errors) {
      eobj = new Error(data.errors);
    } else if (data.message) {
      eobj = new Error(data.message);
    } else {
      eobj = new Error(error.message);
    }
  } else {
    eobj = new Error(error.message);
  }
  return Promise.reject(eobj);
}

export function getBillings(params?) {
  return axios.get(BILLINGS, { params, withCredentials: true }).catch(reject);
}

export function getRules(params?) {
  return axios.get(RULES, { params, withCredentials: false }).catch(reject);
}

export function getSubscriptionStatus(params?) {
  return axios
    .post(SUBSCRIPTION_STATUS, null, { params, withCredentials: true })
    .catch(reject);
}

export function verifyBilling(params) {
  return axios
    .post(VERIFY_BILLING, params, { withCredentials: true })
    .catch((error) => {
      return Promise.reject(error.response);
    });
}

export function verifyBillingForExtendOutlet(params) {
  return axios
    .post(VERIFY_BILLING_FOR_EXTEND_OUTLET, params, { withCredentials: true })
    .catch((error) => {
      return Promise.reject(error.response);
    });
}

export function getFeatureSubscriptionPrice() {
  return axios
    .get(FEATURE_SUBSCRIPTION_PRICE, { withCredentials: false })
    .catch(reject);
}

/*
 @deprecated
 */
export function cancelSubscription(params) {
  return axios
    .put(CANCEL_SUBSCRIPTION, params, { withCredentials: true })
    .catch(reject);
}

export function cancelSubs(featureName) {
  const requestBody: FeatureSubscriptionRequest = {
    active: false,
    feature_name: featureName.feature_name,
  };
  return FeatureSubscriptionControllerApiFactory(
    new Configuration({
      basePath: BUSINESS_SUBSCRIPTION,
    })
  )
    .patchFeatureSubscription(requestBody)
    .then(({ data }) => data);
}

export function getAllOutlets() {
  return getSaudagarOutlets({ active: 'all' }).then((resp) => resp.data);
}

export function updateIsActiveSubcription(outletId, isActive) {
  const params = { id: outletId, isActive };
  return axios
    .put(IS_ACTIVE_SUBCRIPTIONS_URL, params, { withCredentials: true })
    .catch(reject);
}

export function getProratePrice({ params }) {
  return axios
    .get(GET_PRORATE_PRICE, { params, withCredentials: true })
    .catch(reject);
}

export function getDiscountSettings(businessId: number) {
  return DiscountSettingsControllerApiFactory(
    new Configuration({
      basePath: BUSINESS_SUBSCRIPTION,
    })
  )
    .getDiscountSettingsByBusinessId(businessId)
    .then(({ data }) => data)
    .catch(reject);
}

export function getBillingsCalculation(businessId: number) {
  return BillingControllerApiFactory(
    new Configuration({
      basePath: BUSINESS_SUBSCRIPTION,
    })
  )
    .getBillingCalculations(businessId)
    .then(({ data }) => data)
    .catch(reject);
}

export function verifyBillingV2(
  subscriptionDiscountId: number,
  finalPrice: number,
  couponCode: string
) {
  return BillingControllerApiFactory(
    new Configuration({
      basePath: BUSINESS_SUBSCRIPTION,
    })
  )
    .verify({
      coupon_code: couponCode,
      final_price: finalPrice,
      subscription_discount_id: subscriptionDiscountId,
    })
    .then(({ data }) => data)
    .catch((error) => {
      return Promise.reject(error.response);
    });
}
